import { Component, inject, Input, signal, ChangeDetectionStrategy } from '@angular/core';
import { LoggerService } from '../../../core/services/logger.service';
import { TranslationService } from '../../../core/services/translation.service';
import { ButtonComponent } from '../button/button.component';
import { IconComponent } from '../icon/icon.component';

@Component({
  selector: 'app-copy-button',
  standalone: true,
  imports: [ButtonComponent, IconComponent],
  template: `
    <app-button variant="outlined" (click)="copyToClipboard()" [attr.data-testid]="testId">
      <app-icon [name]="copied() ? 'check' : 'clipboard'" />
      {{
        copied()
          ? translate.translate('component.copy.copied')
          : label || translate.translate('component.copy.label')
      }}
    </app-button>
  `,
  changeDetection: ChangeDetectionStrategy.Eager,
  styles: [],
})
export class CopyButtonComponent {
  @Input() text = '';
  @Input() label = '';
  @Input() testId = 'copy-button';

  copied = signal(false);
  protected translate = inject(TranslationService);
  private log = inject(LoggerService).getLogger('copy-button');

  async copyToClipboard() {
    try {
      await window.navigator.clipboard.writeText(this.text);
      this.copied.set(true);

      // Reset after 2 seconds
      setTimeout(() => this.copied.set(false), 2000);
    } catch (err) {
      this.log.error('Failed to copy:', err);
    }
  }
}
